import { Navigate } from "react-router-dom";
import { useIsAuthenticated, useAuth } from "../hooks/useAuth";
import { SignupForm } from "../components/auth/SignupForm";

export function Signup() {
  const isAuthenticated = useIsAuthenticated();
  const { loading } = useAuth();

  if (loading) return null;
  if (isAuthenticated) return <Navigate to="/onboarding" replace />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <SignupForm />
    </div>
  );
}
